import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, setToken, errMsg } from "./api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success(`Welcome, ${data.user.name}`);
      onLogin(data.user);
    } catch (err) {
      toast.error(errMsg(err, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--ink)] px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm"
      >
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/nova-logo.png" alt="N Murthy Groups" className="h-16 w-auto" />
          <h1 className="mt-4 font-serif-display text-3xl text-[var(--cream)]">N Murthy <span className="text-[var(--gold)]">Groups</span></h1>
          <p className="mt-1 text-[10px] uppercase tracking-[0.4em] text-[var(--gold-bright)]">Community App</p>
        </div>
        <div className="rounded-lg border border-white/10 bg-white/[0.03] p-7">
          <p className="mb-6 text-xs uppercase tracking-[0.35em] text-[var(--gold-bright)]">Sign in</p>
          <form onSubmit={submit} className="space-y-6" data-testid="community-login-form">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-white/20 bg-transparent py-3 text-[var(--cream)] outline-none placeholder:text-white/40 focus:border-[var(--gold)]"
              data-testid="community-login-email" />
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-white/20 bg-transparent py-3 text-[var(--cream)] outline-none placeholder:text-white/40 focus:border-[var(--gold)]"
              data-testid="community-login-password" />
            <button type="submit" disabled={loading}
              className="w-full rounded-sm bg-[var(--gold)] py-3.5 text-xs uppercase tracking-[0.25em] text-[#1C2427] transition-transform hover:-translate-y-0.5 disabled:opacity-60"
              data-testid="community-login-btn">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-[var(--cream-3)]">Clients & admin only. Accounts are created by the N Murthy Groups office.</p>
        <a href="/" className="mt-3 block text-center text-xs uppercase tracking-[0.2em] text-[var(--cream-3)] hover:text-[var(--gold-bright)]">← Back to website</a>
      </motion.div>
    </div>
  );
}
